<template>
  <button @click="onClick">
    预约资讯
  </button>
</template>

<script>
export default {
  name: 'BtnContact',
  props: {
    name: {
      type: String,
      default: '',
    },
  },
  methods: {
    onClick() {
      // eslint-disable-next-line no-underscore-dangle
      (window._czc || []).push(['_trackEvent', this.name, 'click', window.location.href]);

      this.$store.dispatch('changeQrcode', '2');
      this.$store.dispatch('changeContactVisible', true);
    },
  },
};
</script>

<style scoped lang="scss">
button {
  border: 0;
  padding: 0;
  font-size: 0;
  background-color: transparent;
  width: percentage(452px / $deviceWidth);
  padding-top: percentage(78px / $deviceWidth);
  background: url("~assets/btn-contact.png") center/contain no-repeat;
  @include hdpi() {
    background-image: url("~assets/btn-contact@2x.png");
  }

  @include mediaWidth(#{$mbWidth}) {
    width: percentage(507px / $mbWidth);
    padding-top: percentage(67px / $mbWidth);
    background: url("~assets/btn-contact-m.png") center/contain no-repeat;
    @include hdpi() {
      background-image: url("~assets/btn-contact-m@2x.png");
    }
  }
}
</style>
